import { useParams } from "react-router-dom";

export type FarmerType = "dairy" | "default";

export const useGetFarmerType = (): FarmerType => {
  const { type } = useParams<{ type?: string }>();

  if (type === "dairy") {
    return "dairy";
  }

  return "default";
};
